// @flow

import type {RenderTag} from '@stripe-internal/markdoc';

// %checks is documented here: https://flow.org/en/docs/types/functions/#toc-predicate-functions
export function isMarkdocAstTag(
  tag: RenderTag | Array<RenderTag>,
): boolean %checks {
  return (
    typeof tag === 'object' && !Array.isArray(tag) && tag.astType === 'Tag'
  );
}
